import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { UserStore } from "./store";
const appStore = new UserStore();

ReactDOM.render(<App appStore={appStore} />, document.getElementById("root"));

// If you want to start measu ring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
